import { createContext } from "react";

type PageSideBarContextProps = {
  collapsed: boolean;
};

export const PageSideBarContext = createContext<PageSideBarContextProps | null>(
  null,
);
